export enum PaymentContainerEnum {
  LOADING = "loading",
  SUMMARY = "summary",
  ERROR = "error",
  PAYMENT = "payment",
}
